<template>
  <div class="login">
    <el-row type="flex" justify="center">
      <el-col :xs="20" :sm="10" :md="8" :lg="6" :xl="6">
        <el-card shadow="hover">
          <div slot="header" class="clearfix">
            <span class="login__header-text-color">
              {{reqPending ? $t('login.header[0]') : $t('login.header[1]')}}
            </span>
          </div>
          <el-form ref="form" :model="form" @submit.prevent.native="onSubmit">
            <el-form-item>
              <el-input
                name="login"
                v-validate="'required'"
                :placeholder="$t('login.form.login')"
                :disabled="reqPending"
                v-model="form.login"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-input
                name="password"
                v-validate="'required'"
                :placeholder="$t('login.form.password')"
                v-model="form.password"
                :disabled="reqPending"
                show-password
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button class="login-button" type="primary" native-type="submit" :disabled="reqPending">{{$t('login.button')}}</el-button>
<!--              <el-button class="login-button" type="primary" native-type="submit" :disabled="reqPending">-->
<!--                <a :href="`https://api.glassen-it.com/component/slogin/provider/isiao/auth?front_redirect=${currentUrl.toString().slice(0,-5)}`">Войти через ИС ИАО</a>-->
<!--              </el-button>-->
            </el-form-item>
          </el-form>
          <el-divider></el-divider>
          <lang-switcher />
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import dictionary from "./validator/dictionary";
import notify from "../../helpers/notify";

// store
import { AUTH_REQUEST, SAVE_USER_LOGIN_DATA, AUTH_CHECK } from "../../store/actions/auth";
import { NEW_REQUESTS_COUNT } from "../../store/actions/manager";

// components
import LangSwitcher from "../../components/langSwitcher/LangSwitcher";

export default {
  name: "Login",
  data() {
    return {
      form: {
        login: '',
        password: ''
      },
      reqPending: false,
      currentUrl: '',
    }
  },
  methods: {
    onSubmit() {
      this.reqPending = true;

      this.$validator.validate().then(result => {
        if (result) {
          this.login();
        } else {
          this.reqPending = false;

          this.$validator.errors.items.forEach(item => {
            notify.call(this, item.msg, "error");
          });
        }
      });
    },
    login() {
      const loginParams = {
        login: this.form.login,
        password: this.form.password
      };



      this.$store
        .dispatch(AUTH_REQUEST, loginParams)
        .then(() => {
          this.$store.dispatch(SAVE_USER_LOGIN_DATA, loginParams);
          this.$store.dispatch(NEW_REQUESTS_COUNT)
          this.reqPending = false;
          this.$router.push("/");
        })
        .catch(() => {
          this.reqPending = false;
          notify.call(this, this.$t('login.notify'), "error");
        });
    }
  },
  created() {
    this.currentUrl = window.location
    this.currentUrl.toString().slice(0,5)
  },
  mounted () {
    this.$validator.localize('ru', dictionary);
  },
  beforeMount () {
    this.$store.dispatch(AUTH_CHECK).then(() => {
        if (localStorage.getItem("access")) window.location.href = '/'
      })
  },
  components: {
    LangSwitcher,
  },
}
</script>

<style>
  @import "./css/style.css";
  .login-button a{
    color: white;
    text-decoration: none;
  }
</style>
